import {
  Http
} from '@/model/Http.js'

export default class mingxi extends Http {
  //佣金明细
  getPronfitMingxList(data) {
    const url = 'api/shouto-platform-balance-log/search'
    return this.postAjax(url, {
      ...data
    })
  }
}



// WEBPACK FOOTER //
// ./src/javaApi/mingxi.js